import WBS from 'js/http';

export default {
	data() {
		return {
			assets: {
				enquadramento_cipa: [],
				grupos: [],
				relacionamento_cnae_cipa: [],
				grau_de_risco: [],
				tecnicos: [],
				sForms: [],
				clientes: [],
			},
		};
	},
	provide() {
		let assets = {};
		for (let asset in this.assets) {
			Object.defineProperty(assets, asset, {
				enumerable: true,
				get: () => this.assets[asset],
			});
		}
		return {
			assets: assets,
			update: () => {
				return this.$refs.tab.updateTable();
			},
		};
	},
	methods: {
		loadPartAsset(part) {
			return new Promise((resolve, reject) => {
				WBS.send(
					'protected-read-assetsMdMapeamento',
					{ part: part },
					(resp) => {
						if (
							resp.status == 'success' &&
							resp.data != undefined
						) {
							resolve(resp.data);
						} else {
							reject();
						}
					}
				);
			});
		},

		LoadAsset(part = null) {
			if (part == null) {
				for (let asset in this.assets) {
					this.LoadAsset(asset);
				}
			} else {
				this.loadPartAsset(part)
					.then((resp) => (this.assets[part] = resp))
					.catch(() => this.LoadAsset(part));
			}
		},
	},
	mounted() {
		this.LoadAsset();
		// this.loadPartAsset('clientes')
	},
};



// WEBPACK FOOTER //
// ./src/components/sst/seguranca/mixins/LoadAssets.js